function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import React from "react";
var _ref2 = /*#__PURE__*/React.createElement("defs", null, React.createElement("linearGradient", {
  id: "b"
}, React.createElement("stop", {
  offset: 0,
  stopColor: "#681938"
}), React.createElement("stop", {
  offset: 1,
  stopColor: "#681938",
  stopOpacity: 0.73308271
})), React.createElement("linearGradient", {
  id: "a"
}, React.createElement("stop", {
  offset: 0,
  stopOpacity: 0.73308271
}), React.createElement("stop", {
  offset: 1,
  stopOpacity: 0
})), React.createElement("clipPath", {
  id: "c"
}, React.createElement("path", {
  d: "M4.347-8.245h127.275v53.968H4.347z"
})));
var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M2.203 3.65l1.692 1.988-.402.338L1.8 4.01z",
  fill: "#b47892",
  fillRule: "evenodd"
});
var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M1.568 4.2l1.67 1.988-.337.275-1.67-1.967z",
  fill: "#c38aa4",
  fillRule: "evenodd"
});
var _ref5 = /*#__PURE__*/React.createElement("path", {
  d: "M6.857 1.407v3.64l-.973-1.123-1.756 1.502-1.693-1.988 1.777-1.502L3.26.816z",
  fill: "#ba788b",
  fillRule: "evenodd"
});
var _ref6 = /*#__PURE__*/React.createElement("path", {
  clipPath: "url(#c)",
  d: "M14.092 9.145l3.223 3.747L6.67 21.887l8.396 9.894 10.644-8.993 3.223 3.823-.075.224c-.6 1.874-1.65 3.448-3.148 4.722-4.722 4.048-12.443 2.85-17.165-2.698-4.722-5.547-4.722-13.342.075-17.39 1.5-1.274 3.298-2.024 5.172-2.323z",
  transform: "translate(-1.415 -1.766) scale(.28222)",
  fill: "#a6a6a6",
  fillRule: "evenodd"
});
var SvgMindsetLogoWashed = function SvgMindsetLogoWashed(_ref) {
  var svgRef = _ref.svgRef,
    props = _objectWithoutProperties(_ref, ["svgRef"]);
  return React.createElement("svg", _extends({
    width: "171px",
    height: "48px",
    viewBox: "0 0 31.347145 7.8161077",
    ref: svgRef
  }, props), _ref2, React.createElement("path", {
    d: "M7.67 1.403h.896v.5q.48-.583 1.143-.583.35 0 .61.145t.424.44q.242-.295.52-.44.28-.145.6-.145.403 0 .683.166.28.162.418.48.1.235.1.76V5.07h-.97V2.976q0-.546-.1-.705-.136-.206-.415-.206-.203 0-.383.124t-.26.366q-.078.238-.078.757v1.76h-.973V3.06q0-.534-.05-.69-.053-.155-.164-.23-.107-.077-.293-.077-.224 0-.403.12-.18.12-.26.35-.075.227-.075.756v1.78h-.97V1.403zm5.744-.497V.008h.97v.898h-.97zm0 4.165V1.405h.97V5.07h-.97zm4.84 0h-.97V3.2q0-.595-.062-.768-.062-.176-.203-.273-.14-.098-.337-.098-.253 0-.453.138-.2.14-.275.367-.073.228-.073.843v1.66h-.97V1.404h.9v.54q.48-.623 1.21-.623.32 0 .587.12.264.113.4.292.137.18.19.41.054.227.054.65v2.28zm3.96 0h-.9v-.538q-.226.314-.533.47-.302.152-.613.152-.632 0-1.084-.508-.45-.51-.45-1.423 0-.932.44-1.416.438-.487 1.108-.487.616 0 1.065.51V.01h.97v5.06zm-2.59-1.912q0 .587.162.85.235.38.656.38.335 0 .57-.284.235-.287.235-.853 0-.63-.228-.907-.23-.28-.586-.28-.345 0-.58.277-.23.272-.23.818z",
    fill: "#ba788b",
    style: {
      lineHeight: "125%",
      textAlign: "start"
    },
    fontWeight: 700,
    fontSize: "7.0731945px",
    fontFamily: "Arial",
    letterSpacing: "0px",
    wordSpacing: "0px"
  }), React.createElement("path", {
    d: "M22.533 3.834h.5v.013q0 .356.205.59.204.232.504.232.287 0 .477-.18t.19-.454q0-.272-.154-.438-.15-.167-.543-.312-.632-.225-.825-.46-.194-.234-.194-.628 0-.446.32-.756.325-.31.785-.31.487 0 .773.275.287.275.308.77h-.52q-.018-.27-.173-.42-.152-.147-.418-.147-.24 0-.398.162-.16.16-.16.397 0 .17.066.286.065.113.217.206.138.087.4.166.266.08.356.117.357.15.523.404.17.25.17.64 0 .49-.343.813-.342.32-.867.32-.535 0-.86-.348-.324-.352-.342-.946zm6.717-.554h-3.43q.046.623.45 1.006t1.01.383q.427 0 .77-.223.34-.224.527-.62h.553q-.263.63-.74.97-.472.338-1.098.338-.828 0-1.402-.59-.573-.592-.573-1.42 0-.867.56-1.434.562-.565 1.436-.565.857 0 1.396.59.54.588.54 1.53v.035zm-.538-.41q-.138-.64-.508-.96-.37-.325-.963-.325-.55 0-.934.35-.384.344-.47.935h2.877zm1.426 2.16V1.72h-.72v-.49h.72V0h.487v1.23h.722v.49h-.722v3.31h-.487z",
    style: {
      lineHeight: "125%",
      textAlign: "start"
    },
    fontWeight: 400,
    fontSize: "7.0731945px",
    fontFamily: "AvantGarde Bk BT",
    letterSpacing: "0px",
    wordSpacing: "0px",
    fill: "gray"
  }), React.createElement("path", {
    d: "M9.05 5.702l-.326 1.634h-.458l.228-1.138-.546 1.138h-.265L7.58 6.218l-.224 1.118h-.16l.328-1.634h.48l.084.986.476-.986h.486zm1.875 0l.128 1.634h-.476l-.027-.355h-.492l-.175.357h-.185l.81-1.634h.417zm-.787 1.115h.402l-.048-.724-.354.724zm3.542-1.115l-.325 1.634h-.363L12.517 6.3l-.207 1.036h-.16l.327-1.634h.3l.52 1.117.225-1.12h.16zm2.03 0l.13 1.634h-.478l-.026-.355h-.492l-.175.357h-.187l.81-1.634h.417zm-.786 1.115h.4l-.047-.724-.353.724zm2.836-.364h.674l-.176.883h-.15l-.03-.113q-.226.14-.446.14-.363 0-.52-.216-.157-.218-.078-.613.077-.385.337-.622.263-.238.606-.238.453 0 .458.462l-.243.102.01-.04.013-.088q.035-.29-.21-.29-.18 0-.276.155-.095.153-.18.57-.077.39-.052.53t.175.14q.175 0 .214-.195l.08-.403h-.235l.03-.164zm3.097-.75l-.032.163h-.585l-.1.494h.492l-.032.164h-.492l-.13.648h.684l-.032.164h-1.16l.328-1.634h1.06zm2.763 0l-.326 1.633h-.457l.227-1.138-.546 1.138h-.264l-.103-1.118-.222 1.118h-.16l.328-1.634h.48l.083.986.476-.986h.486zm2.335 0l-.033.163h-.585l-.1.494h.493l-.033.164h-.492l-.13.648h.685l-.033.164h-1.16l.328-1.634h1.06zm2.44 0l-.327 1.633h-.362L27.23 6.3l-.207 1.036h-.16l.328-1.634h.3l.523 1.117.224-1.12h.16zm2.435 0l-.033.163h-.4l-.296 1.47h-.5l.295-1.47h-.403l.032-.164h1.307z",
    fill: "#a6a6a6",
    style: {
      lineHeight: "125%",
      textAlign: "start"
    },
    fontStyle: "italic",
    fontWeight: 400,
    fontSize: "2.45180559px",
    fontFamily: "Britannic Bold",
    letterSpacing: "0px",
    wordSpacing: "0px"
  }), _ref3, _ref4, _ref5, _ref6);
};
var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgMindsetLogoWashed, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/Mindset Logo Washed.92782b24.svg";
export { ForwardRef as ReactComponent };